import React, { useCallback, useEffect, useState } from 'react';
import { useTable } from 'react-table';
import {
  useNavigate,
  useLocation
} from 'react-router-dom';
import styles from '../styles/Links.module.css';


var BatchName = ''

const Table = ({ columns, data, rowStyle }) => {

  
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  })

  // Render the UI for your table
  return (
    <table {...getTableProps()} className={styles.userTable}>
      <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th {...column.getHeaderProps()}>{column.render('Header')}</th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          //console.log(row)
          prepareRow(row)
          // This cycles over all of the links and displays all of them. They do each have a workerType value
          // in them which can be used to select which to display... or how to display them.
          return (
            <tr
              {...row.getRowProps()}
              className={row.original.active === 0 ? styles.inactiveRow : ""}
            >


            
              {row.cells.map(cell => {
                var Str = ''
                if (cell.value === 'PersonalMultiple') { 
                  Str = <td {...cell.getCellProps()}><b>{cell.render('Cell')}</b></td>
                }
                else {
                    Str = <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                }    
                return Str
              })}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

function MakeLink(input) {
  // Need to update this to resemble what is on the development server.
  // Need to check which server is running the NeuroClinic and make the map to jatos 
  // correctly since they are not running on the same exat sites. 
  //
  
  if ( input[0] != null )
  {
    // Make retake link
    var Str = ''
    // Is this local clinic or remote?
    //console.log(window.location)
    var BasePath = window.location.hostname
    // The server for the NeuroClinic and JATOS are different, even if on the same machine.
    
   if ( BasePath.includes('localhost') )
    { BasePath =  "127.0.0.1" }
   else if ( BasePath === 'ncmlab.ca' )
    { BasePath = "jatos.ncmlab.ca" }
   else if ( BasePath === 'dev.ncmlab.ca')
    { BasePath = "jatos-dev.ncmlab.ca" }


  // Check to see if a port is needed
  // JATOS runs locally on port 9000
    var PortNumber = ''
    if ( ! window.location.port == "" )
    {
      PortNumber = ':9000'
    }

    var Output = window.location.protocol + '//' + BasePath + PortNumber + '/publix/' + input[0] +'?Battery='+input[1]+'&UsageType=Session'
    return (<div><a href={Output} target="_blank">Link</a></div>)
  }
  else { return <div></div> } 
}

function embedLink(inputLink) {
  if ( inputLink != null )
  { return (<div><a href={inputLink} target="_blank">Link</a></div>) }
  else { return <div></div> }
}

function GetSelectedBatchName() {
  // go to the batch pull down and get the name of what is selected
  const dropdown = document.getElementById("BatchSelect");
  const selectedValue = dropdown.value;
  
  var BatchName
  BatchName = document.getElementById('SelectedBatch').innerHTML
  // This if should never occur
  if ( BatchName === '' )
  {
    BatchName = "Default"
  }
  return BatchName
}



const Links = ({ setWorker, study}) => {

  const [users, setUsers] = useState(null);
  const [search, setSearch] = useState("");
  const [selectedBatch, setSelectedBatch] = useState();
  const [dataamount, setDataamount] = useState([]);
  
  const filteredUsers = React.useMemo(() => {
    if (!users) return [];
    const s = search.trim().toLowerCase();
    return users.filter((u) =>
      (u.batch || "").toLowerCase().includes(s) ||
      (u.code || "").toLowerCase().includes(s) ||
      (u.email || "").toLowerCase().includes(s)
    );
  }, [users, search]);
  
  // NAVIGATION LOADING
  // This is added so the View button navigates to the participant profile 
  // page instead of requiring the user to click on the profile tab after 
  // clicking view.
  const navigate = useNavigate();
  const nav = useCallback((path) => {
    navigate(path, { replace: true });
  }, [navigate]);


  
  //fetch(`/get_links/${study.uuid}`)
  useEffect(() => {
    fetch(`/NEWget_all_links/${GetSelectedBatchName()}`)
      .then((response) => response.json())
      .then((data) => {
        // The batch session data is the same for every worker, so parse it once.
        var JSONData = data.batchSessionData != null ? JSON.parse(data.batchSessionData) : null

        // Get the Battery ID if it is there
        var BatteryId
        if ( JSONData && JSONData['BatteryID'] != undefined )
        { BatteryId = JSONData['BatteryID'] }
        else { BatteryId = '9999' }

        // prepare the variables for creating the link in the email
        var baseURL = window.location.hostname

        if ( baseURL.includes('localhost') )
          { baseURL =  "127.0.0.1" }
        else if ( baseURL === 'ncmlab.ca' )
          { baseURL = "jatos.ncmlab.ca" }
        else if ( baseURL === 'dev.ncmlab.ca')
          { baseURL = "jatos-dev.ncmlab.ca" }

        var portNumber = -999
        if ( ! window.location.port == "" )
        { portNumber = ':9000' }

        var protocol = window.location.protocol

        const res = data.links.map((e) => {
          if ( JSONData != null )
          {
            if ( typeof JSONData[e.worker_id] != 'undefined' )
            {
              e.Name = JSONData[e.worker_id+"_FirstName"]
              e.email = JSONData[e.worker_id+"_Email"]
              e.linkStatus = 'In Use'
            }
            else {
              e.linkStatus = 'Available'
            }
            if ( e.active == 0 )
            { e.linkStatus = 'Archived' }
          }
          else {
            e.Name = ''
              e.linkStatus = ''
          }

          return {
            code: e.studyCode,
            //date: e.JASONDATE,
            batch: 'empty', //e.title,
            linkCode: MakeLink([e.studyCode, BatteryId]),
            //data: FindData(e.worker_id),
            linkStatus: e.linkStatus,
            active: e.active,
            name: e.Name,
            //email: e.comment,
            worker:e.worker_id,
            workerType: e.workerType,
            actions: <div> 
              <button onClick={() => {
                // This goes through the information return from mySQL and sends some of it to be part of the "worker"
                
                setWorker({
                  id: e.worker_id,
                  //email: e.comment ? e.comment : e.id,
                  studyCode: e.studyCode,
                  workerType: e.workerType
                });
                // The following decides which display page to present 
                //console.log(worker)
                var whatToDisplay = ''
                if ( e.workerType === "PersonalMultiple" ) 
                { whatToDisplay = "/overview" }
                else { whatToDisplay = "/profile" }
                
                nav(whatToDisplay)
              }
              }>View</button>
              
              <button
                onClick={() => {
                  fetch(`/toggle_active/${e.worker_id}/${1}`, {
                    method: "PUT",
                  })
                    .then(() => {
                      // ✅ Refresh UI after toggle
                      setUsers((prev) =>
                        prev.map((u) =>
                          u.worker === e.worker_id
                            ? { ...u, active: u.active === 0 ? 1 : 0 }
                            : u
                        )
                      );
                    })
                    .catch((err) => alert(err.message));
                }}
              >
                Archive
              </button>
              <button title="Delete this participant" onClick={()=>{
                // This button needs to delete the worker and the worker infor in the batch session data.
                // The following code was auto generated and I am not sure if it is correct.
                if (window.confirm('Are you sure you want to delete this link? This cannot be undone. The row will be deleted upon the next page refresh.')) 
                {
                  fetch(`/toggle_active/${e.worker_id}/${-99}`, {
                    method: "PUT",
                  })
                    .then(() => {
                      // ✅ Refresh UI after toggle
                      setUsers((prev) =>
                        prev.map((u) =>
                          u.worker === e.worker_id
                            ? { ...u, active: u.active === 0 ? 1 : 0 }
                            : u
                        )
                      );
                    })
                  .catch((err) => alert(err.message));
                }
              }}>Delete</button>
            
              </div>,

            email: 
            <div> 
              <button title="Open the general for this participant" onClick={()=>{
                var linkCode = MakeLink([e.studyCode, BatteryId])
                window.open( linkCode.props.children.props.href )}}
              >Open</button>

              <button title="Copy the general link for this participant" onClick={()=>{
                var linkCode = MakeLink([e.studyCode, BatteryId])
                navigator.clipboard.writeText(linkCode.props.children.props.href)
                alert("Link was copied to the clipboard.")
              }
              }>Copy</button>

              <button title="Select a link to a specific experimental phase for this participant" onClick={()=>{
                var linkCode = MakeLink([e.studyCode, BatteryId])
                window.open(linkCode.props.children.props.href+"&CopyLink=true")}}
              >Copy Select</button>
              
              <button onClick={() => {
                // first, check to see if there is an email provided for this person
                if ( e.email ) { 
//                  var TTTURL = protocol+'//'+baseURL+portNumber+'/publix/' + e.studyCode +'?Battery=9999&UsageType=Session'
                  fetch(`/send_test_email/${e.email}/${e.Name}/${e.studyCode}/${baseURL}/${portNumber}/${protocol}`)
                    .then(() => {
                      alert('Test link sent succesfully.');
                    })
                    .catch(error => alert(error.message))
                } else { alert('No email available for this person')}
                }}
              >Email</button>
              

            </div>,
          };
        });
        setUsers(res);
      });
  }, [setWorker, study.uuid]);
  

  
  const columns = React.useMemo(
    () => [
      {
        Header: 'Test',
        columns: [
          /*{
            Header: 'Batch',
            accessor: 'batch',
          },*/
          /*{
            Header: 'Test Start Date/Time',
            accessor: 'date',
          },*/
          {
            Header: 'Worker',
            accessor: 'worker',
          },
          /* {
            Header: 'Worker Type',
            accessor: 'workerType',
          }, */
          {
            Header: 'Actions',
            accessor: 'actions'
          },
          {
            Header: 'Status',
            accessor: 'linkStatus'
          },
          {
            Header: 'Block',
            accessor: 'blockCount'
          },
          {
            Header: 'Name',
            accessor: 'name'
          },
          {
            Header: 'Links',
            accessor: 'email'
          },
        ],
      },
    ],
    []
  )


  if (users === null) return <div className={styles.container}
    style={{ fontSize: "1.5em" }}>
    Loading...
  </div>

  if (users.length === 0) return <div className={styles.container}
    style={{ fontSize: "1.5em" }}>
    No Study Links
  </div>





  return (
  
    <div className={styles.container}>
      <div>
        <div className={styles.activeLinksHeader}>
          <div className={styles.link}/>
          <h2>Study Links</h2>
          <div>
          {selectedBatch}
          </div>
          <div className={styles.searchContainer}>
            <input value={search}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              type="text" placeholder="Search..." />
          </div>

        </div>
        

        <Table columns={columns} data={filteredUsers} />
      </div>
      
    </div>
    
  );
}

export default Links;